import { AutoColumn } from "../../components/Column";
import styled from "styled-components";
import { RowBetween } from "../../components/Row";
import { ThemedText } from "../../theme";
import { Trans } from "@lingui/macro";
import NoDataContent from "../../components/NoDataContent";
import { Coffee, Plus } from "react-feather";
//import { useMiniPool } from '../../hooks/useContract';
import usePkgUsers from "../../hooks/usePkgUsers";
import { USERS_ADDRESS } from "../../constants/address";
// import { MINI_POOL_ADDRESS } from '../../constants/address';
import { useEffect, useMemo, useState } from "react";
import PkgItem from "./components/PkgItem";
import UserItem from "./components/UserItem";

import UserPkgItem from "./components/UserPkgItem";
import { useWallet } from "use-wallet";
import Loader from "../../components/Loader";
import Big from "big.js";

const Wrapper = styled(AutoColumn)`
  max-width: 820px;
  width: 100%;
`;

const ThemedTextWrapper = styled(ThemedText.Black)`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  font-weight: 400;
  font-size: 20px;
`;

const PoolsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 16px;
  column-gap: 16px;
  padding-bottom: 10px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    grid-template-columns: 1fr;
  `};
`;

function Pools() {
  const { account, chainId } = useWallet();
  // const blockNumber = getBlockNumber();
  const userOpt = usePkgUsers(USERS_ADDRESS[chainId]);

  const [loading, setLoading] = useState(true);
  const [pkgs, setPkgs] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [userPkgList, setUserPkgList] = useState([]);

  /*   const sortpkgs = useMemo(() => {
    return pkgs.sort((a, b) => {
      return Number(a.pkgid) > Number(b.pkgid) ? -1 : 1;
    });
  }, [pkgs]); */

  useEffect(() => {
    const fetch = async () => {
      const tmppkgs = await userOpt.getPkgInfoList(setLoading);
      // console.log("getPkgInfoList", pkgs);
      setPkgs(tmppkgs);

      const tmpuserInfo = await userOpt.getUser(account, true, setLoading);
      // console.log("getPkgInfoList", pkgs);
      setUserInfo(tmpuserInfo);
      if (tmpuserInfo.userid > 0) {
        const tmpuserpkglist = await userOpt.getUsersPkgInfoList(
          account,
          setLoading
        );
        setUserPkgList(tmpuserpkglist);
      }
    };
    if (userOpt.userContract) {
      fetch();
    }
    // userOpt, TODO 为什么不能userOpt 导致死循环
  }, [account, userOpt.userContract]);

  return (
    <Wrapper>
      <AutoColumn gap={"24px"} style={{ width: "100%" }}>
        {userInfo && (userInfo.userid==0) && (
          <NoDataContent
            icon={<Plus size={48} />}
            text={
              <>
                <div>
                  <Trans>
                    You are not a member yet. Please purchase our services to
                    become a member.
                  </Trans>
                </div>
                <div>{loading ? <Loader /> : null}</div>
              </>
            }
          />
        )}
          {userInfo && (userInfo.userid!=0) &&      <RowBetween>
          <ThemedTextWrapper>
            <Trans>User Info</Trans>
          </ThemedTextWrapper>
        </RowBetween>}
        {
          
          userInfo && (userInfo.userid!=0) && <UserItem
              userInfo={userInfo}
            
              userOpt={userOpt}
            />
        }

{userPkgList && userPkgList.length>1? <PoolsWrapper>
        {userPkgList &&
          userPkgList.map((userPkgitem) => (
            <UserPkgItem
            
              userPkgInfo={userPkgitem}
              userOpt={userOpt}
            />
          ))}
           </PoolsWrapper>:
           <>
                   {userPkgList &&
          userPkgList.map((userPkgitem) => (
            <UserPkgItem
            
              userPkgInfo={userPkgitem}
              userOpt={userOpt}
            />
          ))}
           </>
          }
        <RowBetween>
          <ThemedTextWrapper>
            <Trans>All Service Packages</Trans>
          </ThemedTextWrapper>
        </RowBetween>
        {account && pkgs && pkgs.length ? (
          <PoolsWrapper>
            {pkgs.map((pkgitem) => (
              <PkgItem key={pkgitem.id} pkgitem={pkgitem} userOpt={userOpt} />
            ))}
          </PoolsWrapper>
        ) : (
          <NoDataContent
            icon={<Coffee size={48} />}
            text={
              <>
                <div>
                  <Trans>All active use Pkg positions will appear here.</Trans>
                </div>
                <div>{loading ? <Loader /> : null}</div>
              </>
            }
          />
        )}
      </AutoColumn>
    </Wrapper>
  );
}

export default Pools;
